/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HistoryInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'any' })
export class HistoryApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Histories');
  }

  find(params?: Record<string, any>): Observable<HistoryInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<HistoryInterface[]>(path, httpParams);
  }

  upsertByInstance(
    name: string,
    type: string,
    learningAreaId: number,
    criteria?: string,
    eduContentId?: number,
    bundleId?: number,
    taskId?: number,
    eduContentBookId?: number
  ): Observable<HistoryInterface> {
    const path = `upsert`;
    const body = { name, type, learningAreaId, criteria, eduContentId, bundleId, taskId, eduContentBookId };
    return this.put<HistoryInterface>(path, undefined, body);
  }
}
